query AnalyticsViewsByTag($filter: AnalyticsViewsFilterInput!, $limit: Int) {
  analyticsViews(filter: $filter) {
    viewsByTag(limit: $limit) {
      tagId
      title
      views
      visitors
    }
  }
}
